import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useMediaQuery';

interface ContactProps {
  onPrivacyClick?: () => void;
}

const Contact: React.FC<ContactProps> = ({ onPrivacyClick }) => {
  const isMobile = useIsMobile();
  
  const MotionWrapper = ({ children, ...props }: any) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return <motion.div {...props}>{children}</motion.div>;
  };
  
  return (
    <footer id="contact" className="bg-black py-20">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left side - Logo */}
          <MotionWrapper
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center lg:justify-start"
          >
            <div className="flex items-center">
              <img 
                src="/assets/logo.png" 
                alt="Koral Convergence" 
                className="h-16 w-auto object-contain"
              />
            </div>
          </MotionWrapper>

          {/* Right side - Contact info */}
          <MotionWrapper
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-center lg:text-right"
          >
            <h2 className="text-2xl lg:text-3xl font-bold text-white mb-6">
              Contact Us
            </h2>
            
            <div className="mb-8">
              <a
                href="mailto:team@koralconvergence.com"
                className="text-white text-lg lg:text-xl hover:text-blue-300 transition-colors duration-300"
              >
                team@koralconvergence.com
              </a>
            </div>

            <div className="text-white/80 text-base lg:text-lg">
              <p className="mb-4">© 2022 Koral Convergence. All rights reserved.</p>
              <button
                onClick={onPrivacyClick}
                className="hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Privacy Policy
              </button>
            </div>
          </MotionWrapper>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
